import * as Inovx from '@shared';
import ConfigurationConstants from './../constants/ConfigurationConstants';
var ConfigurationActions = {

    editConfigurationProperty(comp: string, key: string, value: any): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: ConfigurationConstants.CONFIGURATION_UPDATE_EDIT,
            component: comp,
            key: key,
            value: value
        });
    },
    openConfiguration(configuration: IConfiguration): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: ConfigurationConstants.CONFIGURATION_BEGIN_EDIT,
        });
    },
    finishConfigurationEdit(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: ConfigurationConstants.CONFIGURATION_BEGIN_FINISH,
        });
    },

    
}

export default ConfigurationActions;